<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "VISIT REPORT",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "VISIT REPORT",
      pid: this.$route.params.pid,
      visit_id: this.$route.params.visit,
      service_id: this.$route.params.service,
    };
  },
  computed: {
    ...mapGetters("reports", ["VisitReport","visitReport_status"]),
  },
  methods: {
    ...mapActions({
      FetchVisitReport: "reports/fetchVisitReport",
    }),
        thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  created() {
    let vdata = {
      pid: this.$route.params.pid,
      visit: this.$route.params.visit,
      service: this.$route.params.service,
    };

    this.FetchVisitReport(vdata);
  },
};
</script>
<style lang="css" scoped>
.image {
  left: 50vw;
}
.image img {
  width: 200px;
}

.stamp_date {
  position: relative;
  color: red !important;
  font-size: 20px !important;
  top: -75px;
  left: 5%;
  font-family: Verdana, Geneva, sans-serif;
}
.compla {
  display: inline-flex;
  margin-right: 2px;
  padding: 2px;
}
.print {
  font-family: Verdana, Geneva, sans-serif;
}
hr {
  height: 1px;
  border-width: 0;
  color: gray;
  background-color: gray;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print report</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>
        <div class="bg-white p-2 print">
          <div class="invoice-title p-2">
            <div style="width: 100%; top: 0px; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <b-spinner
                  v-if="visitReport_status"
                  class="m-0"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <img
                  v-else
                  :src="
                    VisitReport.clinic_logo ? VisitReport.clinic_logo : '---'
                  "
                  alt="logo"
                  height="115px"
                />
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <p
                  style="text-transform: uppercase;
                    text-align: right;
                    font-size: 17px;
                    font-weight: bold;"
                >
                  {{ VisitReport ? VisitReport.clinic_name : "---" }}
                </p>
                <table align="right" width="100%" style="font-size: 17px">
                  <tr align="right">
                    <td>
                      <span
                        v-html="
                          VisitReport ? VisitReport.clinic_address : '---'
                        "
                      ></span>
                    </td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Tel:</strong>
                      +256{{ VisitReport ? VisitReport.clinic_contact : "---" }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Email:</strong>
                      {{ VisitReport ? VisitReport.clinic_email : "---" }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-12">
              <table width="100%" style="font-size: 17px">
                <tr>
                  <td>Patient Name:</td>
                  <td>
                    <b> {{ VisitReport ? VisitReport.patient_name : "---" }}</b>
                  </td>
                  <td>Patient Id:</td>
                  <td>
                    <b>{{ VisitReport ? VisitReport.patient_code : "---" }}</b>
                  </td>
                </tr>
                <tr>
                  <td v-if="VisitReport.gender">Gender</td>
                  <td v-if="VisitReport.gender">
                    <b>{{ VisitReport.gender == 1 ? "Male" : "Female" }}</b>
                  </td>
                  <td v-if="VisitReport.age">Age:</td>
                  <td v-if="VisitReport.age">
                    <b>{{ VisitReport.age ? VisitReport.age : "---" }}</b>
                    <span v-if="VisitReport.age_unit == 1">Years</span>
                    <span v-else-if="VisitReport.age_unit == 2">Months</span>
                    <span v-else-if="VisitReport.age_unit == 3">Days</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr>
                  <td v-if="VisitReport.patient_contact">Contact</td>
                  <td v-if="VisitReport.patient_contact">
                    <b>{{
                      VisitReport.patient_contact
                        ? VisitReport.patient_contact
                        : "---"
                    }}</b>
                  </td>
                  <td v-if="VisitReport.weight">Weight:</td>
                  <td v-if="VisitReport.weight">
                    <b>{{
                      VisitReport.weight ? VisitReport.weight + " kg" : "---"
                    }}</b>
                  </td>
                </tr>
                <tr>
                  <td v-if="VisitReport.temperature">Temperature:</td>
                  <td v-if="VisitReport.temperature">
                    <b>{{
                      VisitReport.temperature
                        ? VisitReport.temperature + " &#x2103;"
                        : "---"
                    }}</b>
                  </td>
                  <td v-if="VisitReport.pressure">Blood Pressure:</td>
                  <td v-if="VisitReport.pressure">
                    <b>{{
                      VisitReport.pressure
                        ? VisitReport.pressure + " mmHg"
                        : "---"
                    }}</b>
                  </td>
                </tr>
                <tr>
                  <td>Visit Date:</td>
                  <td>
                    <b>{{ VisitReport.date ? VisitReport.date : "---" }}</b>
                  </td>
                  <td>Print Date:</td>
                  <td>
                    <b>{{
                      VisitReport.printDate ? VisitReport.printDate : "---"
                    }}</b>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <hr style="border-style: dashed; width: 97%" />
          <div class="row">
            <div class="col-12">
              <table
                width="100%"
                style="font-size: 17px"
                border="1"
                cellpadding="3"
                cellspacing="3"
                v-for="(notes, index) in VisitReport.clinicNotes"
                :key="index"
              >
                <tr
                  style="border: 1px solid #ddd"
                  v-if="notes.complaints ? notes.complaints.length : false">
                  <th width="25%" style="padding: 6px">
                   <span v-if="notes.mh">Chief Complaints:</span>
                   <span v-else>Presenting complaints:</span>
                  </th>
                  <td style="padding: 6px">
                    <span v-for="(complaint, index) in notes.complaints" :key="index">
                        <span class="fs-4">
                                {{ complaint.complaint +"," }}
                            </span>
                    </span>
                  </td>
                </tr>
                <tr
                  style="border: 1px solid #ddd"
                  v-if="notes.complaints_history">
                  <th width="25%" style="padding: 6px">
                  History of Presenting complaints:
                  </th>
                  <td style="padding: 6px">
                    <article v-html="notes.complaints_history"></article>
                  </td>
                </tr>

                   <tr
                  style="border: 1px solid #ddd"
                  v-if="notes.mh">
                  <th width="25%" style="padding: 6px">
                  Medical History (M/H):
                  </th>
                  <td style="padding: 6px">
                    <article v-html="notes.mh"></article>
                  </td>
                </tr>
                 <tr
                  style="border: 1px solid #ddd"
                  v-if="notes.examination"
                >
                  <th width="25%" style="padding: 6px">
                  Examination:
                  </th>
                  <td style="padding: 6px">
                    <article v-html="notes.examination"></article>
                  </td>
                </tr>
                  <tr
                  style="border: 1px solid #ddd"
                  v-if="notes.diagnosis"
                >
                  <th width="25%" style="padding: 6px">
                  Diagnosis:
                  </th>
                  <td style="padding: 6px">
                    <article v-html="notes.diagnosis"></article>
                  </td>
                </tr>
                <tr
                  style="border: 1px solid #ddd"
                  v-if="
                    notes.reviewed_systems
                      ? notes.reviewed_systems.length
                      : false
                  "
                >
                  <th width="25%" style="padding: 6px">
                    Review Of Other Systems:
                  </th>
                  <td style="padding: 6px">
                    <table width="100%">
                      <tr style="padding: 6px">
                        <th>System</th>
                        <th>Findings</th>
                      </tr>
                      <tr
                        style="padding: 6px"
                        v-for="(system, i) in notes.reviewed_systems"
                        :key="i"
                      >
                        <td>{{ system.system }}</td>
                        <td v-html="system.diagnosis"></td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr style="border: 1px solid #ddd" v-if="notes.summary">
                  <th width="25%" style="padding: 6px">Summary:</th>
                  <td style="padding: 6px">
                    <article v-html="notes.summary"></article>
                  </td>
                </tr>
                <tr
                  style="border: 1px solid #ddd"
                  v-if="notes.patient_examination != null"
                >
                  <th width="25%" style="padding: 6px">
                    Physical examination:
                  </th>
                  <td style="padding: 6px">
                    <article v-html="notes.patient_examination"></article>
                  </td>
                </tr>
                <tr
                  style="border: 1px solid #ddd"
                  v-if="
                    notes.provisional != null ||
                    notes.provisionalDiagnosis2.length
                  "
                >
                  <th width="25%" style="padding: 6px">
                    Provisional Diagnosis:
                  </th>
                  <td style="padding: 6px">
                    <article
                      v-if="notes.version == 1"
                      v-html="notes.provisional"
                    ></article>
                    <span
                      v-for="(provi, index) in notes.provisionalDiagnosis2"
                      :key="index"
                      v-else
                    >
                      <span class="compla"
                        ><button type="button" class="btn btn-light btn-sm">
                          {{ provi.name, }}
                        </button></span
                      ></span
                    >
                  </td>
                </tr>
                <tr
                  style="border: 1px solid #ddd"
                  v-if="
                    VisitReport.all_tests ? VisitReport.all_tests.length : false
                  "
                >
                  <th width="25%" style="padding: 6px">Investigations:</th>
                  <td style="padding: 6px">
                    <span
                      v-for="(test, index) in VisitReport.all_tests
                        ? VisitReport.all_tests
                        : []"
                      :key="index"
                      ><span class="compla"
                        ><button type="button" class="btn btn-light btn-sm">
                          {{ test.name }}
                        </button></span
                      ></span
                    >
                  </td>
                </tr>

                <tr
                  style="border: 1px solid #ddd"
                  v-if="
                    notes.finalDiagnosis2.length || notes.final_diagnsis != null
                  "
                >
                  <th width="25%" style="padding: 6px">Final diagnosis:</th>
                  <td style="padding: 6px">
                    <article
                      v-if="notes.version == 1"
                      v-html="
                        notes.final_diagnsis ? notes.final_diagnsis : '--'
                      "
                    ></article>
                    <span
                      v-for="(final, index) in notes.finalDiagnosis2"
                      :key="index"
                      v-else
                      ><span class="compla"
                        ><button type="button" class="btn btn-light btn-sm">
                          {{ final.name, }}
                        </button></span
                      ></span
                    >
                  </td>
                </tr>
                <tr
                  style="border: 1px solid #ddd"
                  v-if="notes.description ? notes.description : false"
                >
                  <th width="25%" style="padding: 6px">Description:</th>
                  <td style="padding: 6px">
                    <article v-html="notes.description"></article>
                  </td>
                </tr>

                <tr
                  style="border: 1px solid #ddd"
                  v-if="notes.diagnosis_details"
                >
                  <th width="25%" style="padding: 6px">Diagnosis details:</th>
                  <td style="padding: 6px">
                    <article v-html="notes.diagnosis_details"></article>
                  </td>
                </tr>

                <tr
                  style="border: 1px solid #ddd"
                  v-if="
                    VisitReport.all_drugs
                      ? VisitReport.all_drugs.length
                      : false || VisitReport.all_procedures
                      ? VisitReport.all_procedures.length
                      : false
                  "
                >
                  <th width="25%" style="padding: 6px">Management:</th>
                  <td style="padding: 6px">
                    <span
                      v-if="
                        VisitReport.all_procedures
                          ? VisitReport.all_procedures.length
                          : false
                      "
                    >
                      <h6 class="font-weight-bold">> <b>Procedures</b></h6>

                      <table width="100%">
                        <tr style="padding: 6px">
                          <th>Name</th>
                          <th>Quantity</th>
                        </tr>
                        <tr
                          style="padding: 6px"
                          v-for="(procedure, i) in VisitReport.all_procedures"
                          :key="i"
                        >
                          <td>{{ procedure.name }}</td>
                          <td>{{ procedure.qty }}</td>
                        </tr>
                      </table>
                      <hr />
                    </span>

                    <span
                      v-if="
                        VisitReport.all_drugs
                          ? VisitReport.all_drugs.length
                          : false
                      "
                    >
                      <h6>> Prescriptions</h6>
                      <table
                        width="100%"
                        v-show="
                          VisitReport.all_drugs ? VisitReport.all_drugs : 0
                        "
                      >
                        <tr style="padding: 6px">
                          <th>Drug</th>
                          <th>Prescribed Qty</th>
                          <th>Dispensed Qty</th>
                          <th>Dosage</th>
                        </tr>
                        <tr
                          style="padding: 6px"
                          v-for="(drug, i) in VisitReport.all_drugs"
                          :key="i"
                        >
                          <td>{{ drug.drug_name }}</td>
                          <td>{{ drug.prescribed_qty }}</td>
                          <td>{{ drug.dispensed_qty }}</td>
                          <td>
                            {{ drug.prescription ? drug.prescription : "--" }}
                          </td>
                        </tr>
                      </table>
                    </span>
                  </td>
                </tr>
                <tr style="border: 1px solid #ddd" v-if="notes.recommendation">
                  <th width="25%" style="padding: 6px">Recommendation {{ VisitReport.pyament_setting }}:</th>
                  <td style="padding: 6px">
                    <article v-html="notes.recommendation"></article>
                  </td>
                </tr>

           <tr style="border: 1px solid #ddd" v-if="VisitReport.pyament_setting == 1">
                  <th width="25%" style="padding: 6px">Total Amt</th>
                  <th width="25%" style="padding: 6px">Paid Amt</th><th width="25%" style="padding: 6px">Balance</th>
          </tr>
                <tr v-if="VisitReport.pyament_setting == 1">
                    <td style="padding: 6px">{{VisitReport.payments?thousandSeprator(VisitReport.payments.amount):'--'}}</td>
                    <td style="padding: 6px">{{VisitReport.payments?thousandSeprator(VisitReport.payments.paid):'--'}}</td>
                    <td style="padding: 6px">{{VisitReport.payments?thousandSeprator(VisitReport.payments.amount - VisitReport.payments.paid):'--'}}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="table-responsive">
            <br />
            <br />
            <table width="100%" style="font-size: 17px">
              <tr>
                <center>
                  <p>Signature ..........................................</p>
                </center>
              </tr>
              <tr>
                <td>
                  <center>
                    Thank you for trusting
                    {{
                      VisitReport.clinic_name ? VisitReport.clinic_name : "---"
                    }}
                  </center>
                </td>
              </tr>
              <tr>
                <td>
                  <center>
                    For more inquiries call
                    {{
                      VisitReport.clinic_contact
                        ? VisitReport.clinic_contact
                        : "---"
                    }}
                  </center>
                </td>
              </tr>

              <tr v-if="VisitReport.branding_setting == 1">
                <div style="text-align: center">
                  <p >
                    Report Printed by
                    {{ VisitReport.printuser ? VisitReport.printuser : "---" }}
                    via Clinic Plus Hospital Software
                  </p>
                </div>
              </tr>
            </table>
          </div>
          <div class="image" v-show="VisitReport.clinic_stamp">
            <img :src="VisitReport.clinic_stamp" alt="stamp" />
            <div class="stamp_date">{{ VisitReport.printDate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>
